import React from 'react';
import styles from './style.module.css';
import '../carousel.css'

import { LuDollarSign } from "react-icons/lu";
import { LuShieldCheck } from "react-icons/lu";
import { LuCalendar } from "react-icons/lu";
import { LuBarChart4 } from "react-icons/lu";
import { LuSettings } from "react-icons/lu";
import { LuClock3 } from "react-icons/lu";
import { Carousel } from 'react-bootstrap';
import Heading from '../../components/Heading';
import SubHeading from '../../components/SubHeading';


interface AdvantageItem {
    icon: React.ReactNode;
    title: string;
    description: string;
}

const advantages: AdvantageItem[] = [
    {
        icon: <LuCalendar />,
        title: 'Reservation-Based Charging',
        description: 'Eliminate wait times and optimize charger utilization with our advanced reservation system. EV drivers can schedule charging sessions in advance through our user-friendly app.',
    },
    {
        icon: <LuDollarSign />,
        title: 'Reduced Costs',
        description: 'Start generating revenue without high initial investment or ongoing subscriptions. Our flexible financial models allow property owners to choose the option that best suits their business needs.',
    },
    {
        icon: <LuShieldCheck />,
        title: 'Hands-Off Management',
        description: 'BreatheEV handles everything from installation to maintenance. Our 24/7 monitoring ensures optimal performance and 99% uptime for all charging stations.',
    },
    {
        icon: <LuBarChart4 />,
        title: 'Revenue Generation',
        description: 'Create a new income stream from your parking assets. Property partners earn monthly revenue from charging fees while providing a valuable amenity to tenants and visitors.',
    },
    {
        icon: <LuSettings />,
        title: 'Nationwide Service',
        description: 'Our network of installers and maintenance teams covers all 50 U.S. states, ensuring fast, reliable service no matter where your property is located.',
    },
    {
        icon: <LuClock3 />,
        title: 'Quick Implementation',
        description: 'From site survey to system launch, our streamlined process gets your EV charging solution up and running efficiently, with minimal disruption to your property.',
    },
];

const Home_3: React.FC = () => {
    return (


        <section className={styles.advantagesSection}>
            <div className={'container'}>
                <span className={styles.subtitle}>Key Advantages</span>
                <Heading topBottomMargin={14}>Why Property Owners Choose BreatheEV</Heading>
                <SubHeading bottomMargin={'20px'}>
                    Our comprehensive EV charging solution combines innovative technology with smart business models
                    to deliver maximum value with minimal hassle.
                </SubHeading>
                {/* <p className={styles.description}>
                    Our comprehensive EV charging solution combines innovative technology with smart business models
                    to deliver maximum value with minimal hassle.
                </p> */}


                <div className={styles.cardGrid}>
                    {advantages.map((adv, index) => (
                        <div className={styles.card} key={`main-${index}`}>
                            <div className={styles.icon}>{adv.icon}</div>
                            <h3 className={styles.boxTitle}>{adv.title}</h3>
                            <p className={styles.boxContent}>{adv.description}</p>
                        </div>
                    ))}
                </div>

                <div className={`mobile-carousel2 ${styles.cardGridMobile}`}>
                    <Carousel interval={15000} data-bs-theme="dark" nextIcon prevIcon>
                        {advantages.map((adv, index) => (
                            <Carousel.Item key={`mobile-${index}`}>
                                <div className={styles.card}>
                                    <div className={styles.icon}>{adv.icon}</div>
                                    <h3 className={styles.boxTitle}>{adv.title}</h3>
                                    <p className={styles.boxContent}>{adv.description}</p>
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>


            </div>
        </section>



    );
};

export default Home_3;
